const sideOptions = [{
    title: '账户信息',
    child: [{
      name: '基础信息',
      key: 'accountInfos',
      toRouter: '/account/infos',
    }]
  },
  {
    title: '信息管理',
    child: [
      {
        name: '综合信息管理',
        key: 'informationInfos',
        toRouter: '/information/infos',
      },
      {
        name: '人才管理',
        key: 'talentsInfos',
        toRouter: '/talents/infos',
      },
      {
        name: '培训视频管理',
        key: 'informationTrainingvideo',
        toRouter: '/informationTrainingvideo',
      }
    ]
  },
  {
    title: '系统管理',
    child: [{
        name: '用户管理',
        key: 'systemUser',
        toRouter: '/system/user',
      },
      {
        name: '用户统计',
        key: 'userStatistics',
        toRouter: '/system/userStatistics',
      }
    ]
  }
]

const nameMap = sideOptions.reduce((pre, cur) => {
  cur.child &&
    cur.child.forEach(childItem => {
      if (pre[childItem.key]) console.error('是否有重复的key' + childItem.key)
      pre[childItem.key] = cur.title
    })
  return pre
}, {})

module.exports = {
  sideOptions,
  // 映射表
  nameMap
}